var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c("page-header", {
        attrs: {
          light: "",
          "dark-crumb": "",
          title: "Пользовательское соглашение",
        },
      }),
      _c("content-wrapper-block", [
        _c("div", { staticClass: "agreement" }, [
          _c("div", { staticClass: "agreement-text" }, [
            _c("p", [
              _c("b", [_vm._v("1. ОБЩИЕ ПОЛОЖЕНИЯ")]),
              _c("br"),
              _vm._v(
                " 1.1 АО «ГК ОСНОВА» (далее — Администратор) предлагает Пользователям присоединиться к настоящему Пользовательскому соглашению (далее – Соглашение) на условиях, указанных в данном документе."
              ),
              _c("br"),
              _vm._v(
                " 1.2 Настоящее Соглашение определяет условия использования Сайта."
              ),
              _c("br"),
              _vm._v(
                " 1.3 Совершение любых действий по использованию Сайта является безусловным принятием (акцептом) Пользователем условий Соглашения."
              ),
              _c("br"),
              _vm._v(" 1.4 Соглашение определяет:"),
              _c("br"),
              _vm._v(" - порядок использования Сайта;"),
              _c("br"),
              _vm._v(
                " - политику конфиденциальности в отношении сбора и обработки пользовательских данных при использовании Сайта. "
              ),
            ]),
            _c("p", [
              _c("b", [_vm._v("2. ТЕРМИНЫ И ОПРЕДЕЛЕНИЯ")]),
              _c("br"),
              _c("b", [_vm._v("Персональные данные")]),
              _vm._v(
                " - любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу (субъекту персональных данных)."
              ),
              _c("br"),
              _c("b", [_vm._v("Администратор")]),
              _vm._v(
                " - АО «ГК ОСНОВА», зарегистрированный по адресу: 142702, Московская обл., город Видное, поселок городского типа Бутово, территория жилой комплекс Бутово-Парк, д. 18, пом. 59."
              ),
              _c("br"),
              _c("b", [_vm._v("Пользователь")]),
              _vm._v(
                " – физическое лицо, намеревающееся принять Пользовательское соглашение или принявшее его, а также использующее Сайт посредством информационно-телекоммуникационной сети Интернет."
              ),
              _c("br"),
              _c("b", [_vm._v("Сайт")]),
              _vm._v(
                " – это совокупность текстов, графических элементов, дизайна, изображений, программного кода, и иных результатов интеллектуальной деятельности, содержащихся в информационно-телекоммуникационной сети Интернет под доменным именем «zk-mainstreet.ru», а также его поддоменов. "
              ),
            ]),
            _c("p", [
              _c("b", [_vm._v("3. УСЛОВИЯ ИСПОЛЬЗОВАНИЯ САЙТА")]),
              _c("br"),
              _vm._v(
                " 3.1 Использование Сайта означает, что Пользователь ознакомился и принимает Соглашение, изложенное на данной странице. Если Пользователь не ознакомился и (или) не принимает данные условия, то Пользователь обязан покинуть Сайт."
              ),
              _c("br"),
              _vm._v(
                " 3.2 Администратор оставляет за собой право в любое время изменять условия Соглашения и рекомендует Пользователю регулярно просматривать его, чтобы знать обо всех изменениях. Продолжение использования Сайта после внесения Администратором изменений будет означать согласие Пользователя с измененными условиями."
              ),
              _c("br"),
              _vm._v(
                " 3.3 Предоставление доступа к Сайту и возможности информационного взаимодействия с Пользователем посредством Сайта осуществляются Администратором исключительно в информационных целях."
              ),
              _c("br"),
              _vm._v(
                " 3.4 Пользователь вправе в свободной форме и по своему усмотрению знакомиться с содержимым Сайта."
              ),
              _c("br"),
              _vm._v(
                " 3.5 Пользователь вправе при обнаружении ошибок в работе Сайта или в размещенном на нем контенте сообщить об этом Администратору."
              ),
              _c("br"),
              _vm._v(
                " 3.6 Пользователь подтверждает, что он является дееспособным и достиг возраста, необходимого в соответствии с законодательством Российской Федерации для совершения сделок, предусмотренных Соглашением."
              ),
              _c("br"),
              _vm._v(
                " 3.7 Использование материалов Сайта без письменного согласия Администратора не допускается."
              ),
              _c("br"),
              _vm._v(
                " 3.8 Использование общедоступных сведений или иной информации, доступ к которой не ограничен, разрешено при соблюдении установленных федеральными законами ограничений в отношении распространения такой информации."
              ),
              _c("br"),
              _vm._v(
                " 3.9 Пользователь обязуется не предпринимать несанкционированные и (или) неправомерные действия в отношении Сайта, в том числе любые действия, направленные на нарушение работы Сайта или его компонентов."
              ),
              _c("br"),
              _vm._v(" 3.10 Администратор вправе:"),
              _c("br"),
              _vm._v(
                " - изменять, дорабатывать и обновлять Сайт без согласия и уведомления Пользователя;"
              ),
              _c("br"),
              _vm._v(
                " - устанавливать любые ограничения на использование Сайта;"
              ),
              _c("br"),
              _vm._v(
                " - проводить профилактические работы, влекущие приостановление работы Сайта. "
              ),
            ]),
            _c("p", [
              _c("b", [_vm._v("4. ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ")]),
              _c("br"),
              _vm._v(
                " 4.1 В целях исполнения Соглашения в соответствии с требованиями, установленными Федеральным законом «О персональных данных» от 27.07.2006 N 152-ФЗ, Администратор вправе собирать и обрабатывать персональные данные Пользователей и файлы cookies."
              ),
              _c("br"),
              _vm._v(
                " 4.2 Порядок обработки и защита персональных данных Пользователей определяется настоящим Соглашением и Политикой обработки персональных данных, расположенной по адресу "
              ),
              _c(
                "a",
                {
                  staticClass: "breakable-link",
                  attrs: {
                    href: "/Политика_обработки_персональных_данных.pdf",
                    target: "_blank",
                  },
                },
                [
                  _vm._v(
                    "https://zk-mainstreet.ru/Политика_обработки_персональных_данных.pdf"
                  ),
                ]
              ),
              _vm._v("."),
              _c("br"),
              _vm._v(
                " 4.3 Администратор в отношении обработки персональных данных Пользователей выступает в роли оператора персональных данных - лицо, самостоятельно организующее и/или осуществляющее обработку персональных данных, а также определяющее цели обработки персональных данных, состав обрабатываемых персональных данных и конкретные действия (операции) с такими персональными данными."
              ),
              _c("br"),
              _vm._v(
                " 4.4 При посещении Сайта Администратор собирает файлы cookies. Порядок обработки файлов cookies определяется Политикой использования Cookies, расположенной по адресу "
              ),
              _c("a", { attrs: { href: "/cookie-policy", target: "_blank" } }, [
                _vm._v("https://zk-mainstreet.ru/cookie-policy"),
              ]),
              _vm._v(". "),
            ]),
            _c("p", [
              _c("b", [_vm._v("5. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ")]),
              _c("br"),
              _vm._v(" 5.1 Администратор не несет ответственности за:"),
              _c("br"),
              _vm._v(
                " - невозможность использования Сайта по причинам, не зависящим от Администратора;"
              ),
              _c("br"),
              _vm._v(
                " - убытки, причинённые в результате использования Сайта."
              ),
              _c("br"),
              _vm._v(
                " 5.2 Соглашение регулируется и толкуется в соответствии с законодательством Российской Федерации. Вопросы, не урегулированные Соглашением, подлежат разрешению в соответствии с законодательством Российской Федерации."
              ),
              _c("br"),
              _vm._v(
                " 5.3 Соглашение может быть изменено или дополнено Администратором без уведомления Пользователя. Новая редакция Соглашения вступает в силу с момента ее размещения на Сайте. Пользователь обязан своевременно знакомится с действующим Соглашением."
              ),
              _c("br"),
              _vm._v(
                " 5.4 Действующая версия Соглашения размещена в открытом доступе на Сайте: https://zk-mainstreet.ru/agreement. "
              ),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }